<template>
  <div>
    <Table
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :initialValues="initialValues"
      :tableFooter="false"
    >
      <template #tableRow="{ request }">
        <tr class="font-sans text-xs border-b border-brand-gray-300 w-full">
          <slot name="tableRow" :request="request">
            <td
              class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
            >
              {{ getLookupText(modules, request.moduleID) }}
            </td>
            <td
              class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
            >
              {{ request.fileNumber }}
            </td>
            <td
              class="px-6 py-2 text-gray-700 text-xs font-normal border-r border-brand-gray-300 text-wrap"
            >
              {{ getLookupText(administrativeRegions, request.issueImmigDeptID) }}
            </td>
            <td
              class="px-6 py-2 text-gray-700 text-xs font-normal border-r border-brand-gray-300 text-wrap"
            >
              {{ getLookupText(fileStatus, request.fileStatus) }}
            </td>
          </slot>

          <td class="px-6 py-2">
            <div class="flex items-center justify-center">
              <div class="flex items-center justify-center gap-2 w-20 h-10">
                <slot name="tableOperation" :request="request">
                  <tippy
                    :theme="
                      useThemeStore().currentScheme == 'light' ? 'light-border' : 'dark-border'
                    "
                    :arrow="false"
                    :offset="[0, 4]"
                    interactive
                    trigger="click"
                    v-bind="{ ...(maxDate && { maxDate: new Date() }) }"
                    placement="bottom-end"
                  >
                    <button class="rounded p-1 bg-gray-600" @click.prevent="">
                      <faBars class="w-3 fill-white" />
                    </button>
                    <template #content>
                      <div class="flex flex-col gap-y-2 max-h-[12rem] overflow-y-auto">
                        <button
                          @click="printOldFile(request)"
                          class="text-start px-3 py-1.5 text-sm text-brand-black-secondary hover:text-primary-700 hover:bg-gray-200"
                        >
                          {{ getLookupText(props.modules, request.moduleID) }} -
                          {{ getLookupText(props.transaction, 23173, 'nameId') }}
                        </button>
                      </div>
                      <!-- TODO: actionListPerService -->
                    </template>
                  </tippy>
                </slot>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </Table>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Table from '@/components/Table/index.vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useThemeStore } from '@/stores/theme'
import faBars from '@/assets/icons/faBars.svg?component'

const i18n = useI18n()
const router = useRouter()

const props = defineProps({
  tableData: {
    type: Array,
    default: () => []
  },
  initialValues: {
    type: Object,
    default: () => {}
  },
  modules: {
    type: Array
  },
  administrativeRegions: {
    type: Array
  },
  fileStatus: {
    type: Array
  },
  transaction: {
    type: Array
  }
})

const tableHeaders = ref([
  {
    value: 1,
    label: i18n.t('FileModuleVisaOrResidency')
  },
  {
    value: 2,
    label: i18n.t('fileNumber')
  },
  {
    value: 3,
    label: i18n.t('issuingPlace')
  },
  {
    value: 4,
    label: i18n.t('fileStatus')
  },
  {
    value: 5,
    label: i18n.t('isNotEnableToPrintAction')
  }
])

const getLookupText = (entry, id, key) => {
  return entry?.find((v) => (key ? v[key] == id : v?.id == id))?.text || ''
}

const printOldFile = (info) => {
  router.push({
    name: 'ServiceForm',
    query: {
      expD: true,
      withException: false,
      isCanceled: 0,
      isUser: true,
      fileNumber: info.fileNumber,
      sponsoredUN: info.unifiedNumber,
      administrativeRegionId: info.issueImmigDeptID,
      moduleId: info.moduleID
    },
    params: {
      serviceId: info.serviceTransactionID
    }
  })
}
</script>

<style></style>
